import React from "react";
import { Table, Th, Thead, Tr, Td } from "reactable";
import { appHelpers } from "../../_helpers";

// const success_response = "Successfully Proccessed";
// const failed_response = "Failed to process manifest";

const ManifestSummary = ({ records }) => {
      const manifestSummary = JSON.parse(records.ManifestSummary)
      console.log(manifestSummary, 'manifest');
      return (
    <div>
      <Table
        className="table table-striped table-hover"
        id="table"
        sortable={true}
        itemsPerPage={15}
        pageButtonLimit={10}
      >
        <Thead>
          <Th width={200} column="FlightNumber">
            <span>Flight Number</span>
          </Th>
          <Th width={200} column="FlightDate">
            <span>Flight Date</span>
          </Th>
          <Th width={200} column="PaxCount">
            <span>Passengers</span>
          </Th>
          <Th column="Status">
            <span>Status</span>
          </Th>
        </Thead>

        {manifestSummary.map((item, i) => (
          <Tr key={i}>
            <Td column="FlightNumber">{item.FlightNumber}</Td>
            <Td column="FlightDate">
              {appHelpers.formatDate(item.FlightDate)}
            </Td>
            <Td column="PaxCount">
              {appHelpers.numberWithCommasOnly(item.PaxCount)}
            </Td>
            <Td column="Status">
              {/* { (item.Status !== success_response) ?
                            `${failed_response}` : `${success_response}`
                        } */}
              {item.Status}
            </Td>
          </Tr>
        ))}
      </Table>
    </div>
  );
};

export default ManifestSummary;



// WEBPACK FOOTER //
// ./src/views/uploadManifest/manifest_summary.js